(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './lodashFpConvert', '../object/update'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./lodashFpConvert'), require('../object/update'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.lodashFpConvert, global.update);
    global.convert = mod.exports;
  }
})(this, function (exports, _lodashFpConvert, _update) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.convertLodashFp = exports.default = exports.convert = undefined;


  /**
   * Wraps an <code>updater</code> function, returning a new function taking <code>object</code>, <code>path</code> and <code>…args</code> as parameters.<br/>
   * The <code>updater</code> function is invoked with <code>value</code> and <code>…args</code>.<br/>
   * Be carefull, the <code>updater</code> function must not mutate its <code>value</code> argument.
   * @function
   * @memberof util
   * @param {function} updater The updater function.
   * @return {function} Returns the wrapped function.
   * @example <caption>Wrapping an updater</caption>
   * const inc = (v, i = 1) => v + i // this function increments a number with an optional value which defaults to 1
   * const incProp = convert(inc)
   * const object = { nested: { prop: 4 } }
   * incProp(object, 'nested.prop') // => { nested: { prop: 5 } }
   * incProp(object, 'nested.prop', 2) // => { nested: { prop: 6 } }
   * @see {@link object.update|update} for more information.
   * @since 0.2.0
   */
  var convert = function convert(updater) {
    return function (obj, path) {
      for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }

      return _update.update.apply(undefined, [obj, path, updater].concat(rest));
    };
  };
  exports.convert = convert;
  exports.default = convert;


  /**
   * Converts and wraps a lodash/fp function.
   * @function
   * @memberof util
   * @param {function} fn The lodash/fp function.
   * @return {function} Returns the wrapped function.
   * @see {@link util.convert|convert} for more information.
   * @since 0.2.0
   * @private
   */
  var convertLodashFp = exports.convertLodashFp = function convertLodashFp(fn) {
    return convert((0, _lodashFpConvert.lodashFpConvert)(fn));
  };
});